import React from 'react';
import CommonBlog from './CommonBlog';

const Blog = () => {
  return <CommonBlog items={false} count={4} />;
};

export default Blog;
